export default __webpack_public_path__ + "static/media/leads-black-icon.7ecbcaef.svg";